import React from 'react'
import { VelocityTransitionGroup } from 'velocity-react'

const TrGroup = ({ children }) => {
	return(
		<VelocityTransitionGroup
			enter={{
				animation: 'slideDown',
				display: 'flex'
			}}
			leave={{
				animation: 'slideUp'
			}}
			className='rt-tr-group'
		>
			{children}
		</VelocityTransitionGroup>
	)
}

export default TrGroup
